import { defineMessages } from 'react-intl';

export const localOffersMessages = defineMessages({
  'localOffers:locationPermissionDenied': {
    id: 'localOffers:locationPermissionDenied',
    defaultMessage: 'Location permission denied. Please enable it in your settings to continue.',
    description: 'Error message displayed when the user denies location permission for local offers',
  },
});
